<template>
  <Modal :id="id" title="NATE Credit?" :hideClose="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12 text-center">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
          <h4>Would you like to receive NATE credit for this course?</h4>
          <p class="font-size-sm">
            A fee is associated with all courses in My Learning Center that
            offer NATE credit.
          </p>
          <div class="form-group">
            <SwitchField
              name="is_nate"
              on-label="Yes"
              off-label="No"
              v-model="isNate"
            />
          </div>
        </div>
        <template v-if="!!isNate">
          <div class="col-12">
            <div class="form-group">
              <Field
                type="text"
                name="nate_id"
                placeholder="NATE ID"
                v-model="nateId"
              />
            </div>
          </div>
          <template v-if="$root.isIcpDealer">
            <div class="col-12">
              <div class="form-group">
                <Field
                  type="text"
                  name="student_first_name"
                  placeholder="Student First Name"
                  v-model="studentFirstName"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <Field
                  type="text"
                  name="student_last_name"
                  placeholder="Student Last Name"
                  v-model="studentLastName"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <Field
                  type="text"
                  name="student_email"
                  placeholder="Student Email"
                  v-model="studentEmail"
                />
              </div>
            </div>
          </template>
          <div class="col-12">
            <div class="form-group">
              <Field
                type="checkbox"
                name="update_all"
                id="cb_update_all"
                label="Apply to all NATE courses for this student in the enrollment queue"
                v-model="updateAll"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="save">Submit</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [ModalMixin, DisplaysAlerts],
  data() {
    return {
      id: "edit-nate-credit-modal",
      enrollment: null,
      isNate: 0,
      nateId: null,
      studentFirstName: null,
      studentLastName: null,
      studentEmail: null,
      updateAll: 1,
      type: "online",
    };
  },
  methods: {
    validate() {
      var errors = [];
      if (!this.isNate) {
        return true;
      }
      if (!this.nateId) {
        errors.push("NATE ID is required");
      }
      if (this.$root.isIcpDealer) {
        if (!this.studentFirstName) {
          errors.push("Student First Name is required");
        }
        if (!this.studentLastName) {
          errors.push("Student Last Name is required");
        }
        if (!this.studentEmail) {
          errors.push("Student Email is required");
        }
      }
      if (errors.length > 0) {
        this.parseErrors(errors);
        return false;
      }
      return true;
    },
    save() {
      if (!this.validate()) {
        return;
      }
      var url = this.route("enroll.online.cart.nate", {
        type: this.enrollment.item_type.replace("_", "-"),
        enrollment: this.enrollment.id,
      });
      var data = {
        is_nate: this.isNate,
        nate_id: this.nateId,
        update_all: this.updateAll,
      };
      if (this.$root.isIcpDealer) {
        data.student_first_name = this.studentFirstName;
        data.student_last_name = this.studentLastName;
        data.student_email = this.studentEmail;
      }
      this.axios.post(url, data).then(() => {
        this.resolve();
      });
    },
  },
  created() {
    this.enrollment = _.cloneDeep(this.options.enrollment);
    this.type = this.options.type ?? "online";
    this.isNate = !!this.enrollment.nate_id ? 1 : 0;
    this.nateId = this.enrollment.nate_id || null;
    this.studentFirstName = this.enrollment.student_first_name || null;
    this.studentLastName = this.enrollment.student_last_name || null;
    this.studentEmail = this.enrollment.student_email || null;
  },
};
</script>